export type AuthResponseType = {
  access_token?: string; // For backwards compatibility
  token?: string; // Standard token field from login endpoint
  token_type?: string;
  refresh_token?: string;
  redirect?: string;
  action?: string;
  // New magic link response format
  jwt?: string;
  redirect_url?: string;
  user_id?: string;
  email?: string;
};

/**
 * Magic Link Validation Request
 */
export type MagicLinkValidationRequest = {
  token: string;
};

/**
 * Magic Link Validation Response
 */
export type MagicLinkValidationResponse = AuthResponseType;

/**
 * Magic Link Authentication State
 */
export enum MagicLinkAuthState {
  IDLE = "idle",
  VALIDATING = "validating",
  SUCCESS = "success",
  ERROR = "error",
  INVALID_TOKEN = "invalid_token",
  EXPIRED_TOKEN = "expired_token",
}

/**
 * Magic Link Error Type
 */
export type MagicLinkError = {
  message: string;
  code?: string;
  state: MagicLinkAuthState;
};
